<template>
  <div>

    <v-container class="pa-6" fluid>
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="pa-6" outlined>
          <v-card-title class="headline mb-4">
            Manual Acceso Remoto
          </v-card-title>

          <v-divider class="my-4"></v-divider>

          <v-card-text>
            <ol class="pl-4">
              <li class="mb-4">
                Descargar Amazon WorkSpaces Client para tu dispositivo:
                <a
                  href="https://escuelakpi.club/Amazon+WorkSpaces.msi"
                  target="_blank"
                >
                  descargar
                </a>
              </li>

              <li class="mb-4">
                Accede con el siguiente código:
                <v-chip color="primary" text-color="white" class="ml-2">
                  SLiad+64X6JP
                </v-chip>
              </li>

              <li class="mb-4">
                Ingresa con las credenciales que se muestran en el menú
                <RouterLink :to="{ name: 'RolesTeachers' }">Academico / Roles</RouterLink>
                 teacher, consultas los grupos, y das click en el nombre del grupo y en la parte de abajo viene el usuario y contraseña.
              </li>
            </ol>

            <v-alert type="info" class="mt-6">
              Nota: Solo puede haber una sesión remota abierta, si se hacen dos conexiones simultaneas, la primera sesión se descontectará y solo quedará activa la última conexión.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </div>
</template>

<script>
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import validarErrores        from '@/mixins/validarErrores';

  export default {

    components:{
      Alerta,
      carga,
    },

    data() {
      return {
        password: "inbi@DESKTOP1996",
      };
    },

    mixins: [ validarErrores ],

    methods: {
      copiarPassword() {
        navigator.clipboard.writeText(this.password);
        this.$emit("copiado", this.password);
      },
    },

  }

</script>
